import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["dependencies", "editor", "theme", "editable", "transformOptions", "code", "renderToolbar", "onChange", "beforeCompile", "afterCompile"],
    _excluded2 = ["classPrefix", "icon", "className", "buttonClassName"];

/* eslint-disable @typescript-eslint/no-var-requires */
import { useEffect, useState, useCallback } from 'react';
import CodeIcon from '@rsuite/icons/Code';
import classNames from 'classnames';
import { transform as transformCode } from 'sucrase';
import CodeEditor from './CodeEditor';
import Preview from './Preview';
import canUseDOM from './utils/canUseDOM';
import evalCode from './utils/evalCode';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";

var React = require('react');

var ReactDOM = require('react-dom');

var defaultTransformOptions = {
  transforms: ['jsx']
};
var Renderer = React.forwardRef(function (props, ref) {
  var dependencies = props.dependencies,
      _props$editor = props.editor,
      editor = _props$editor === void 0 ? {} : _props$editor,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'light' : _props$theme,
      _props$editable = props.editable,
      isEditable = _props$editable === void 0 ? false : _props$editable,
      _props$transformOptio = props.transformOptions,
      transformOptions = _props$transformOptio === void 0 ? defaultTransformOptions : _props$transformOptio,
      code = props.code,
      renderToolbar = props.renderToolbar,
      onChange = props.onChange,
      beforeCompile = props.beforeCompile,
      afterCompile = props.afterCompile,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classPrefix = editor.classPrefix,
      codeIcon = editor.icon,
      editorClassName = editor.className,
      buttonClassName = editor.buttonClassName,
      editorProps = _objectWithoutPropertiesLoose(editor, _excluded2);

  var _useState = useState(isEditable),
      editable = _useState[0],
      setEditable = _useState[1];

  var _useState2 = useState(null),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(null),
      compiledReactNode = _useState3[0],
      setCompiledReactNode = _useState3[1];

  var handleExpandEditor = useCallback(function () {
    setEditable(!editable);
  }, [editable]);
  var handleError = useCallback(function (error) {
    setErrorMessage(error.message);
  }, []);

  var prefix = function prefix(name) {
    return classPrefix ? classPrefix + "-" + name : name;
  };

  var executeCode = useCallback(function (pendCode) {
    if (pendCode === void 0) {
      pendCode = code;
    }

    if (!canUseDOM) {
      return;
    }

    var originalRender = ReactDOM.render; // Redefine the render function, which will reset to the default value after `eval` is executed.

    ReactDOM.render = function (element) {
      setCompiledReactNode(element);
    };

    try {
      var beforeCompileCode = (beforeCompile === null || beforeCompile === void 0 ? void 0 : beforeCompile(pendCode)) || pendCode;

      if (beforeCompileCode) {
        var _transformCode = transformCode(beforeCompileCode, transformOptions),
            compiledCode = _transformCode.code;

        evalCode((afterCompile === null || afterCompile === void 0 ? void 0 : afterCompile(compiledCode)) || compiledCode, _extends({
          React: React,
          ReactDOM: ReactDOM
        }, dependencies));
      }
    } catch (err) {
      console.warn(err);
    } finally {
      // Reset the render function to the original value.
      ReactDOM.render = originalRender;
    }
  }, [code, dependencies, beforeCompile, transformOptions, afterCompile]);
  useEffect(function () {
    executeCode(code);
  }, [code, executeCode]);
  var handleCodeChange = useCallback(function (code) {
    onChange === null || onChange === void 0 ? void 0 : onChange(code);
    executeCode(code);
    setErrorMessage(null);
  }, [executeCode, onChange]);

  var codeButton = /*#__PURE__*/_jsx("button", {
    role: "switch",
    "aria-checked": editable,
    "aria-label": "Show the full source",
    className: classNames(prefix('btn'), prefix('btn-xs'), buttonClassName),
    onClick: handleExpandEditor,
    children: typeof codeIcon !== 'undefined' ? codeIcon : /*#__PURE__*/_jsx(CodeIcon, {
      className: classNames(prefix('icon'), prefix('icon-code'))
    })
  });

  var showCodeEditor = editable && code;
  var hasError = !!errorMessage;
  return /*#__PURE__*/_jsxs("div", _extends({
    className: "rcv-container"
  }, rest, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(Preview, {
      hasError: hasError,
      errorMessage: errorMessage,
      onError: handleError,
      children: compiledReactNode
    }), /*#__PURE__*/_jsx("div", {
      className: "rcv-toolbar",
      children: renderToolbar ? renderToolbar(codeButton) : codeButton
    }), showCodeEditor && /*#__PURE__*/_createElement(CodeEditor, _extends({}, editorProps, {
      key: "jsx",
      onChange: handleCodeChange,
      className: classNames(editorClassName, 'rcv-editor'),
      editorConfig: {
        lineNumbers: true,
        theme: "base16-" + theme
      },
      code: code
    }))]
  }));
});
export default Renderer;